module.exports = __webpack_public_path__ + "vue/img/doc.c541a9a1.png";